import { createAction, props } from '@ngrx/store';
import { CameraSettings, DvrSettings } from '../model/dvr-settings';
import { FilterItem } from '@fc-vehicles/components/shared/vehicle-filter/vehicles-filter.component';
import { Vehicle, VehicleGroup } from '@fc-core';
import { SelectionVehicle } from '../../settings/models/dvr-settings.model';

export const loadDvrSettings = createAction('[DvrSettings] Load DvrSettings');

export const loadCurrentDvrSettings = createAction(
  '[DvrSettings] Load Current DvrSettings',
  props<{ cameraId: number }>(),
);
export const loadCurrentDvrSettingsSuccess = createAction(
  '[DvrSettings] Load Current DvrSettings Success',
  props<{ dvrSettings: DvrSettings }>(),
);
export const loadDvrSettingsSuccess = createAction(
  '[DvrSettings] Load DvrSettings Success',
  props<{ dvrSettings: DvrSettings[] }>(),
);

export const setDvrSettingsFilters = createAction(
  '[DvrSettings] Set DvrSettings Filters',
  props<{ filters?: FilterItem[]; filter?: FilterItem }>(),
);

export const setDvrSelectedVehicles = createAction(
  '[DvrSettings] Set DvrSettings Selected Vehicle',
  props<{ vehicles: SelectionVehicle[] }>(),
);

export const setDvrSettingsVehicle = createAction(
  '[DvrSettings] Set DvrSettings Vehicle',
  props<{ vehicle: Vehicle }>(),
);

export const setDvrVehicleGroupFilter = createAction(
  '[DvrSettings] Set DvrSettings Vehicle Group Filter',
  props<{ vehicleGroups: VehicleGroup[] }>(),
);

export const setDvrSettingsSearchText = createAction(
  '[DvrSettings] Set DvrSettings Search Text',
  props<{ searchText: string }>(),
);

export const updateManyDvrSetting = createAction(
  '[DvrSettings] Update Many Dvr Setting',
  props<{ cameraSettingsList: CameraSettings; cameraIds: number[] }>(),
);

export const updateManyDvrSettingSuccess = createAction(
  '[DvrSettings] Update Many Dvr Setting Success',
  props<{ cameraSettingsList: CameraSettings; cameraIds: number[] }>(),
);

export const dvrSettingsFailure = createAction(
  '[DvrSettings] Load DvrSettings Failure',
  props<{ error: any }>(),
);
